import React, { FC } from "react";

import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Container from "@mui/material/Container";

const SocialHeader: FC = () => {
  const phoneNumber = "+380980965020";
  const email = "info@ibanoplata.com";

  const links = {
    viber: `viber://chat?number=${phoneNumber}`,
    telegram: `https://t.me/${phoneNumber}`,
    email: `mailto:${email}`,
  };

  return (
    <Box
      sx={{
        p: "12px 0",
        backgroundColor: "#F5F8FF",
        display: { xs: "none", sm: "block" },
      }}
    >
      <Container sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Link
          href={links.viber}
          sx={{ mr: 2.5 }}
          underline="none"
          color="textPrimary"
        >
          Viber
        </Link>
        <Link
          href={links.telegram}
          sx={{ mr: 2.5 }}
          underline="none"
          color="textPrimary"
        >
          Telegram
        </Link>
        <Box sx={{ borderLeft: "solid 1px #000" }} />
        <Link
          href={links.email}
          sx={{ ml: 2.5 }}
          underline="none"
          color="textPrimary"
        >
          {email}
        </Link>
      </Container>
    </Box>
  );
};

export default SocialHeader;
